import { render, staticRenderFns } from "./taskReport.vue?vue&type=template&id=67dc4833&scoped=true&"
import script from "./taskReport.vue?vue&type=script&lang=js&"
export * from "./taskReport.vue?vue&type=script&lang=js&"
import style0 from "./taskReport.vue?vue&type=style&index=0&id=67dc4833&scoped=true&lang=css&"
import style1 from "./taskReport.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dc4833",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67dc4833')) {
      api.createRecord('67dc4833', component.options)
    } else {
      api.reload('67dc4833', component.options)
    }
    module.hot.accept("./taskReport.vue?vue&type=template&id=67dc4833&scoped=true&", function () {
      api.rerender('67dc4833', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DevDashboard/products/workspace/Engineers/taskReport.vue"
export default component.exports